import { render } from "./SyncPrompt.vue?vue&type=template&id=225878ea&scoped=true"
import script from "./SyncPrompt.vue?vue&type=script&lang=ts"
export * from "./SyncPrompt.vue?vue&type=script&lang=ts"

import "./SyncPrompt.vue?vue&type=style&index=0&id=225878ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-225878ea"

export default script